<ng-container *transloco="let convert;">
  @if (isVisible) {
    <div>
      <header>
        <h3 class="text-brand fw-normal" tabindex="-1" #heading>
          {{convert('sellModule.offers.withdraw.textWithdrawOffer')}}
        </h3>
      </header>
      <div id="disclosures">
        <p [innerHTML]="convert('sellModule.offers.withdraw.textBuyerAccept')"></p>
      </div>
      <div class="mb-4">
        <app-datalist-item
          class="mb-4"
          label="{{convert('sellModule.offers.withdraw.labelCounterOffer')}}"
          [value]="get('amount', false) ? (get('amount', false) | currency: 'USD':'symbol':'1.0-0') : 'N/A'"
        ></app-datalist-item>
      </div>
      <div class="mb-4">
        <app-datalist-item class="mb-4" label="{{convert('sellModule.offers.withdraw.labelSellerComment')}}" [value]="offer.comment || 'N/A'"></app-datalist-item>
      </div>
      <form [formGroup]="commentForm">
        <div class="d-flex flex-column app-textarea">
          <div class="form-group mb-0">
            <label class="d-block text-start" for="counter-offer-comment">{{convert('sellModule.offers.common.labelComment')}}</label>
            <textarea
              id="counter-offer-comment"
              class="form-control mb-1"
              rows="3"
              maxlength="150"
              formControlName="offerComment"
              appCharacterCount
              #comment="appCharacterCount"
              (keyup)="replaceInvalidCharacters($event)"
            ></textarea>
            <app-character-count
              [count]="comment.count$ | async"
              [maxLength]="150"
              [characterCountTranslate]="characterCountData">
            </app-character-count>
            <div class="error-message" aria-live="polite" tabindex="-1">
              @if (localErrorMessage) {
                <strong>{{localErrorMessage}}<br /></strong>
              }
            </div>
          </div>
        </div>
      </form>
      <div class="d-flex flex-column flex-lg-row lg-justify-content-start gap-3">
        <div class="visually-hidden d-none" aria-live="polite">Withdrew offer</div>
        <button
          class="btn btn-primary"
          type="submit"
          data-track-elem="button"
          [attr.data-track-name]="'Withdraw-' + inventoryItem.inventoryItemUuid"
          data-track-trigger="offer"
          [attr.data-track-region]="offer.dealershipName"
          [attr.data-track-id]="inventoryItem.inventoryItemUuid"
          (click)="withdraw()"
          >
          {{convert('sellModule.offers.withdraw.btnWithdraw')}}
        </button>
        <button
          class="ms-lg-2 mt-2 mt-lg-0 btn btn-link"
          type="button"
          data-track-elem="button"
          data-track-name="Cancel"
          data-track-trigger="close"
          (click)="cancel.emit()"
          >
          <span>{{convert('common.btnCancel')}}</span>
        </button>
      </div>
    </div>
  }
</ng-container>
